
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { IMessage } from '@/utils/types'
import { ACTION_USER } from '@/store/actions'

@Options({
  components: {},
  directives: { maska },
})
export default class UserMixin extends Vue {
  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  async onDelete(messages: IMessage) {
    this.$q
      .dialog({
        title: this.$t('confirm'),
        message: this.$t('are_you_sure_you_want_to_delete'),
        cancel: true,
        persistent: true,
      })
      .onOk(async () => {
        const success = await this.$store.dispatch(ACTION_USER.DELETE, messages._id)
        if (success) {
          this.$q.notify({
            message: this.$t('messages.deleted'),
            color: 'positive',
          })
        }
      })
  }
}
